import { useEffect, useState } from 'react';
import { dbSupabase } from '../lib/dbClient';

// A subtle strip of the Tier 1 club crests across the top of the hero.
// Reads the same live editor-DB view as ExploreTeams; only shows clubs that
// actually have a badge uploaded. Renders nothing if none are available.
export default function HeroBadges() {
  const [clubs, setClubs] = useState([]);

  useEffect(() => {
    let active = true;
    if (!dbSupabase) return undefined;
    (async () => {
      const { data, error } = await dbSupabase
        .from('public_clubs')
        .select('id,name,badge_url')
        .eq('tier', 1)
        .order('name');
      if (!active || error || !data) return;
      setClubs(data.filter((c) => c.badge_url));
    })();
    return () => { active = false; };
  }, []);

  if (clubs.length === 0) return null;

  return (
    <div className="hero-badges" aria-hidden="true">
      {clubs.map((c) => (
        <img
          key={c.id}
          className="hero-badge"
          src={c.badge_url}
          alt=""
          title={c.name}
          loading="lazy"
        />
      ))}
    </div>
  );
}
